import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { InstructorActions, InstructorApiActions } from './instructor.actions';
import { catchError, map, of, switchMap } from 'rxjs';
import { CalendarService } from '../../services/calendar/calendar.service';
import { ObjectUtilsService } from '../../services/core/object-utils.service';

@Injectable()
export class InstructorEffects {
    constructor(
        private actions$: Actions,
        private calendarService: CalendarService,
        private objectUtilsService: ObjectUtilsService
    ) {}

    loadInstructors$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(InstructorApiActions.loadInstructors),
            switchMap(() =>
                this.calendarService.loadInstructors().pipe(
                    map((instructors) => this.objectUtilsService.buildNames(instructors)),
                    map((instructors) => InstructorActions.loadInstructorsSuccess({ instructors })),
                    catchError((error) => of(InstructorActions.loadInstructorsFailure({ error })))
                )
            )
        );
    });
}
